import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useLang } from "@/contexts/LanguageContext";
import { PageHeader, Card, Badge, fmtMoney } from "@/components/ui-kit";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";

export default function Performance() {
  const { t } = useLang();
  const [data, setData] = useState(null);
  useEffect(() => { (async () => { const r = await api.get("/dashboard/executive"); setData(r.data); })(); }, []);

  if (!data) return <div className="text-slate-500">{t("loading")}</div>;

  return (
    <div data-testid="performance-page">
      <PageHeader title={t("performance")} subtitle="Sales rep KPIs & territory performance"/>

      <Card className="p-5 mb-6">
        <h3 className="text-lg font-semibold mb-4" style={{ fontFamily: "Manrope" }}>Rep Performance (30d)</h3>
        {data.rep_performance.length > 0 ? (
          <ResponsiveContainer width="100%" height={350}>
            <BarChart data={data.rep_performance}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0"/>
              <XAxis dataKey="name" stroke="#64748b" fontSize={11}/>
              <YAxis stroke="#64748b" fontSize={11}/>
              <Tooltip/>
              <Legend/>
              <Bar dataKey="visits" fill="#0ea5e9" name="Visits"/>
              <Bar dataKey="sales" fill="#1d4ed8" name="Sales (EGP)"/>
              <Bar dataKey="collections" fill="#10b981" name="Collections (EGP)"/>
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <div className="text-center py-12 text-slate-400">No performance data yet</div>
        )}
      </Card>

      <Card>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-slate-50 border-y text-xs uppercase tracking-wider text-slate-500">
                <th className="py-2 px-3 text-start">Rep</th>
                <th className="py-2 px-3 text-end">Visits (30d)</th>
                <th className="py-2 px-3 text-end">Sales (30d)</th>
                <th className="py-2 px-3 text-end">Collections (30d)</th>
                <th className="py-2 px-3 text-start">Score</th>
              </tr>
            </thead>
            <tbody>
              {data.rep_performance.map(r => {
                const score = r.visits * 1 + (r.sales > 0 ? Math.log10(r.sales) * 5 : 0) + (r.collections > 0 ? Math.log10(r.collections) * 3 : 0);
                const sBadge = score > 30 ? "green" : score > 15 ? "amber" : "slate";
                return (
                  <tr key={r.rep_id} className="border-b border-slate-100">
                    <td className="py-2 px-3 font-semibold">{r.name}</td>
                    <td className="py-2 px-3 text-end">{r.visits}</td>
                    <td className="py-2 px-3 text-end font-bold text-blue-700">{fmtMoney(r.sales)}</td>
                    <td className="py-2 px-3 text-end font-bold text-emerald-700">{fmtMoney(r.collections)}</td>
                    <td className="py-2 px-3"><Badge color={sBadge}>{score.toFixed(1)}</Badge></td>
                  </tr>
                );
              })}
              {data.rep_performance.length === 0 && (
                <tr><td colSpan="5" className="text-center py-12 text-slate-400">No data</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
